import { ADD, DELETE, GET, UPDATE } from '../common-actions.js';

export const REPORTS_HISTORY = "REPORTS_HISTORY";
export const REPORTS_HISTORY_ADD = REPORTS_HISTORY + ADD;
export const REPORTS_HISTORY_GET = REPORTS_HISTORY + GET;
export const REPORTS_HISTORY_DELETE = REPORTS_HISTORY + DELETE;
export const REPORTS_HISTORY_REMOVE = REPORTS_HISTORY + "_REMOVE";
export const REPORTS_HISTORY_SET = REPORTS_HISTORY + "_SET";
export const REPORTS_HISTORY_UPDATE = REPORTS_HISTORY + UPDATE;
export const REPORTS_HISTORY_DOWNLOAD = REPORTS_HISTORY + "_DOWNLOAD";
export const REPORTS_HISTORY_REFRESH = REPORTS_HISTORY + "_REFRESH";